import { AuthState } from '@/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState : AuthState = {
  loading: true,
  authenticated: false,
  user: null,
  supportNumber: process.env.REACT_APP_SUPPORT_NUMBER,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    set: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    reset: (state, action) => initialState,
    setSupportNumber: (state, action) => {
      return { ...state, supportNumber: action.payload };
    },
  },
});

export const { set, reset, setSupportNumber } = authSlice.actions;

export default authSlice.reducer;
